import API_CONSTANT from 'constants/apiConstant';
import { put, takeEvery } from 'redux-saga/effects';
import { triggerValidateMobileApiCallSuccess } from 'redux/actions';
import { TRIGGER_VALIDATE_MOBILE_API_CALL } from 'redux/actionTypes';
import { apiCall } from 'services';
import { ChangeHistory } from 'utils';

function* triggerValidateMobileApiCall(actions) {
	const { data, callback } = actions;
	yield put(triggerValidateMobileApiCallSuccess());
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.POST_PE_V1,
		url: API_CONSTANT.URL.VALIDATE_MOBILE,
		method: 'POST',
		data,
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		delete apiData['p2p'];
		if (apiData) {
			callback && callback(apiData);
			if (apiData?.isOnPostPe) {
				yield put(triggerValidateMobileApiCallSuccess(apiData));
				ChangeHistory(`push`, `/send-money/amount-insertion`);
			}
		}
	}
}

export default function* triggerValidateMobileApiCallSaga() {
	yield takeEvery(TRIGGER_VALIDATE_MOBILE_API_CALL, triggerValidateMobileApiCall);
}
